let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a4qNu")).then(() => parcelRequire('6x7wA'));